import { render, staticRenderFns } from "./TheRecipePopup.vue?vue&type=template&id=c888251c&scoped=true&"
import script from "./TheRecipePopup.vue?vue&type=script&lang=js&"
export * from "./TheRecipePopup.vue?vue&type=script&lang=js&"
import style0 from "./TheRecipePopup.vue?vue&type=style&index=0&id=c888251c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c888251c",
  null
  
)

export default component.exports